import type { CopilotProvider } from "../types";
import { apiWithAuth } from "@/lib/axios";

/**
 * Provider gestionado por Orkestria.
 * El frontend NO necesita API key — la usa el backend internamente.
 * El backend hace de proxy hacia el upstream configurado en su .env
 * (Ollama Cloud, Groq, etc.).
 *
 * El campo `apiKey` aquí se usa para el JWT del usuario actual (passthrough).
 */
export const orkestriaProvider: CopilotProvider = {
  id: "orkestria",
  label: "Orkestria (gestionado)",
  defaultBaseUrl: "",
  defaultModel: "",

  async listModels() {
    // El usuario no elige modelo — lo decide el servidor.
    return [];
  },

  async chat({ apiKey, systemPrompt, messages, tools, signal, turnId, restaurantId }) {
    if (!apiKey) {
      throw new Error("Sesión no válida.");
    }
    try {
      const { data } = await apiWithAuth.post(
        "/me/copilot/chat",
        {
          systemPrompt,
          messages,
          tools,
          turnId,
          ...(restaurantId ? { restaurantId } : {}),
        },
        apiKey,
        { signal },
      );
      return {
        content: data?.content ?? "",
        toolCalls: Array.isArray(data?.toolCalls) ? data.toolCalls : [],
        meta: { usage: data?.usage },
      };
    } catch (err: any) {
      const status = err?.response?.status;
      const body = err?.response?.data;
      const detail =
        body?.message ||
        err?.message ||
        "Error consultando al copiloto.";
      if (status === 429) {
        // Errores de límite — preservamos info útil
        const e: Error & {
          isLimitError?: boolean;
          code?: string;
          usage?: unknown;
        } = new Error(detail);
        e.isLimitError = true;
        e.code = body?.code;
        e.usage = body?.usage;
        throw e;
      }
      if (status === 503) {
        throw new Error(
          "El copiloto no está disponible en este momento. Intenta más tarde.",
        );
      }
      throw new Error(detail);
    }
  },
};
